//things that make the interface cool
import * as $ from "jquery";
import * as Cookies from "js-cookie";
import "bootstrap";
import "select2";
import "selectize";
import "jquery-validation";
import sortable from "html5sortable/dist/html5sortable.cjs";

export default (function () {
    // Toggle the icon on navbar collapse/expand
    $("#navbarSupportedContent").on("show.bs.collapse", function () {
        // Change icon to 'times' when navbar is expanded
        $(".navbar-toggler .fas").removeClass("fa-bars").addClass("fa-times");
    });
    $("#navbarSupportedContent").on("hide.bs.collapse", function () {
        // Change icon back to 'bars' when navbar is collapsed
        $(".navbar-toggler .fas").removeClass("fa-times").addClass("fa-bars");
    });

    //enable deep links to tabs on profile pages
    const hash = window.location.hash;
    if (hash) {
        $('.profile-tab[href="' + hash + '"]').tab("show");
    }

    // Sortable configuration
    const sortableConfig = {
        acceptFrom: ".sortable",
        items: ".crm-card",
        placeholderClass: "bg-light border-dashed p-5 mb-2",
        itemSerializer: (serializedItem, sortableContainer) => {
            return {
                id: serializedItem.node.dataset.id,
                position: serializedItem.index + 1,
            };
        },
        containerSerializer: (serializedContainer) => {
            return {
                status: serializedContainer.node.dataset.status,
            };
        },
    };

    // Re-callable sortable initializer
    function initSortable() {
        const els = document.querySelectorAll(".sortable");
        if (els.length === 0) return;
        try {
            sortable(".sortable", "destroy");
        } catch (e) {
            // Not yet initialized, safe to ignore
        }
        sortable(".sortable", sortableConfig);
    }

    initSortable();

    // Event delegation for sortupdate — bound once on document, survives re-renders
    document.addEventListener("sortupdate", function (e) {
        var container = e.target;
        if (
            !container ||
            !container.classList ||
            !container.classList.contains("sortable")
        )
            return;

        // For cross-container drags, only process the destination container
        if (
            e.detail.destination &&
            e.detail.destination.container !== container
        )
            return;

        var allSortables = Array.from(document.querySelectorAll(".sortable"));
        var containerIndex = allSortables.indexOf(container);
        if (containerIndex === -1) return;

        Livewire.dispatch("updateColumn", {
            item: e.detail.item.dataset.id,
            originStatus: e.detail.origin.container.dataset.status,
            destinationStatus: e.detail.destination.container.dataset.status,
            orderData: sortable(".sortable", "serialize")[containerIndex],
        });
    });

    // Re-initialize sortable after Livewire updates so new items become draggable
    var sortableReinitPending = false;
    function scheduleSortableReinit() {
        if (sortableReinitPending) return;
        sortableReinitPending = true;
        setTimeout(function () {
            initSortable();
            sortableReinitPending = false;
        }, 100);
    }

    if (typeof Livewire !== "undefined" && Livewire.hook) {
        Livewire.hook("commit", function ({ succeed }) {
            succeed(function () {
                scheduleSortableReinit();
            });
        });
    } else {
        document.addEventListener("livewire:init", function () {
            Livewire.hook("commit", function ({ succeed }) {
                succeed(function () {
                    scheduleSortableReinit();
                });
            });
        });
    }

    $("body").on("change", ".checkbox-toggler", function () {
        var el = $(this).data("toggle-class");
        console.log(el);
        $("." + el).toggle();
    });

    //save and publish buttons
    $(".save-and-redirect").on("click", function () {
        const formId = $(this).data("form");
        const redirectUrl = $(this).data("redirect");

        const $form = $("#" + formId);
        if (!$form.length) {
            console.error(`Form with id ${formId} not found`);
            return;
        }

        let $redirect = $form.find('input[name="redirect_to"]');
        if (!$redirect.length) {
            $("<input>")
                .attr({
                    type: "hidden",
                    name: "redirect_to",
                    value: redirectUrl,
                })
                .appendTo($form);
        }

        $form.submit();
    });

    // Function to handle card selection
    function selectCard(card) {
        // Remove the 'card-selected' class from all cards
        $(".order-card").removeClass("card-selected");

        // Revert the .btn text in all cards
        $(".order-card .btn-outline-primary").each(function () {
            $(this).html($(this).data("original-text"));
        });

        // Add the 'card-selected' class to the selected card
        $(card).addClass("card-selected");

        // Change the .btn text to a Font Awesome checkmark in the selected card
        $(card)
            .find(".btn-outline-primary")
            .html('<i class="fas fa-check"></i> Selected');

        // Get the selected card's data
        var packageType = $(card).data("id");
        var packagePrice = $(card).data("price");
        var retailPrice = $(card).data("retail-price");
        var discount = $(card).data("discount");
        var packageOutlets = $(card).data("outlets");
        var packagePriceId = $(card).data("price-id");

        // Update the product content section
        $(".package-type").text(
            "Type: " +
                packageType.charAt(0).toUpperCase() +
                packageType.slice(1)
        );
        $(".package-outlets").text(packageOutlets);
        $(".package-price").text("$" + packagePrice);
        $(".retail-price").text("$" + retailPrice);
        $(".discount-display").text("-$" + discount);
        $(".price-id").val(packagePriceId);

        // Update the select input
        $("#credit_type").val(packageType);
        $('input[name="credit_type"]').val(packageType);
        $(".packageName").text(packageType);

        // Determine if the credit box should be shown
        var availableCredits = 0;
        var creditElement = $('.credit-balance[type="' + packageType + '"]');
        if (creditElement.length > 0) {
            availableCredits = parseInt(creditElement.text().trim(), 10);
        }

        if (availableCredits > 0) {
            $(".credit-redeem-button").show();
        } else {
            $(".credit-redeem-button").hide();
        }
    }

    // Click event for order cards
    $(".order-card").on("click", function () {
        selectCard(this);
    });

    // click premium
    $(".order-card").first().trigger("click");

    // Save the original text of the buttons
    $(".order-card .btn-outline-primary").each(function () {
        $(this).data("original-text", $(this).html());
    });

    // Function to handle direct click on the "Select" button within the card
    $(".order-card .btn-outline-primary").on("click", function (e) {
        e.preventDefault();
        $(this).closest(".order-card").trigger("click");
    });

    // Change event for the select dropdown
    $("#credit_type").on("change", function () {
        var selectedType = $(this).val();
        var selectedCard = $('.order-card[data-id="' + selectedType + '"]');
        selectCard(selectedCard);
    });

    $(".has-validation form").validate({
        rules: {
            email: {
                required: true,
                minlength: 2,
            },
        },
    });

    $(".line-placeholder").each(function () {
        let width = $(this).data("width");
        $(this).delay(100).css("width", width);
    });

    $(".set-cookie-button").on("click", function (e) {
        e.preventDefault();
        var cookie = $(this).data("cookie");
        var value = $(this).data("value");
        var hide = $(this).data("hide");
        if (hide) {
            $(hide).fadeOut();
        }
        Cookies.set(cookie, value);
    });

    /*

    Chatbot

    */
    $("a.open-chatbot").on("click", function (e) {
        e.preventDefault();
    });

    /*

     On Radio Button Div Toggle

     */
    $("input.radio-toggle-option[type=radio]")
        .change(function () {
            $(".radio-tabs .radio-tab, .tab-to-hide").hide();
            $(".should-be-required").attr({ disabled: true, required: false });
            var show = $(this).data("show");
            var tabToShow = $("." + show);
            tabToShow.show();
            tabToShow
                .find(".should-be-required")
                .attr({ disabled: false, required: true });
        })
        .trigger("change");
    $("input.radio-toggle-option[type=radio]:checked").trigger("change");

    /*

     On Checkbox Check Div Toggle

     */
    $("input.check-toggle-option[type=checkbox]")
        .change(function () {
            var show = $(this).data("show");
            var tabToShow = $("." + show);
            if ($(this).is(":checked")) {
                tabToShow.show();
            } else {
                tabToShow.hide();
            }
        })
        .trigger("change");

    /*

    Toggle & Disappear

    */
    $(".toggle-and-disappear").on("click", function (e) {
        e.preventDefault();
        var togglingDiv = $(this).data("toggle");
        $(this).hide();
        $("#" + togglingDiv).fadeIn();
    });

    /*

     Checkbox Bool Values

     */

    $('input[type="checkbox"].checkbox-bool-value').change(function () {
        this.value = Number(this.checked);
    });

    $('[data-toggle="tooltip"]').tooltip();
    $('[rel="tooltip"]').tooltip({ trigger: "hover" });

    $(".toggle-show-link").on("click", function (e) {
        e.preventDefault();
        var showDiv = $(this).data("show");
        var hideDiv = $(this).data("hide");
        $("." + showDiv).fadeIn();
        $("." + hideDiv).hide();
    });

    $("#app").on("change", ".item-select-checkbox", function () {
        var itemIds = $.map(
            $(".item-select-checkbox:checked:visible"),
            function (n, i) {
                return n.value;
            }
        );
        if (itemIds.length) {
            $(".bulk-select-display")
                .show()
                .find(".number-selected")
                .text(itemIds.length);
            $(".no-bulk-selections").hide();
        } else {
            $(".no-bulk-selections").show();
            $(".bulk-select-display").hide();
        }
        $(
            ".multiple-action-toolbar a.ajax-add-to-list, .multiple-action-toolbar a.ajax-set-status"
        )
            .attr("data-model", itemIds.join(","))
            .attr("data-item", itemIds.join(","));
    });

    $(".select-all-items").on("click", function (e) {
        e.preventDefault();
        $(".item-select-checkbox").prop("checked", "checked").trigger("change");
        $(".fair-use-warning").hide();
    });

    // Add this to handle pagination clicks
    $(document).on("click", ".pagination .page-link", function () {
        $(".deselect-all-items").trigger("click");
    });

    var is_bulk = false;

    $(".select-all-from-search").on("click", function (e) {
        e.preventDefault();
        var totalAllowed = parseInt($(".total-allowed").text(), 10);
        var total = $(".total-records").text();
        var totalNumber = parseInt(total.replace(/,/g, ""), 10);

        if (totalNumber > totalAllowed || !totalNumber)
            total = totalAllowed + " (Max)";

        $(".bulk-select-display").show().find(".number-selected").html(total);
        is_bulk = true;
        $(".fair-use-warning").show();
    });

    $(".deselect-all-items").on("click", function (e) {
        e.preventDefault();
        $(".item-select-checkbox:checked")
            .prop("checked", false)
            .trigger("change");
    });

    /*

    Dropdown madness

    */
    $("#app").on("click", ".dropdown-menu a.dropdown-toggle", function (e) {
        if (!$(this).next().hasClass("show")) {
            $(this)
                .parents(".dropdown-menu")
                .first()
                .find(".show")
                .removeClass("show");
        }
        var $subMenu = $(this).next(".dropdown-menu");
        $subMenu.toggleClass("show");

        $(this)
            .parents("li.nav-item.dropdown.show")
            .on("hidden.bs.dropdown", function (e) {
                $(".dropdown-submenu .show").removeClass("show");
            });

        return false;
    });

    $("#app").on("click", ".dropdown", function () {
        this.closable = false;
    });
    $("#app").on("shown.bs.dropdown", ".dropdown", function () {
        this.closable = false;
    });
    $("#app").on("hide.bs.dropdown", ".dropdown", function () {
        return this.closable;
    });

    $("body").on("click", function (e) {
        if (
            !$(".dropdown").is(e.target) &&
            $(".dropdown").has(e.target).length === 0 &&
            $(".open").has(e.target).length === 0
        ) {
            $(".dropdown-menu").removeClass("show");
        }
    });

    $("#app").on("click", ".dropdown-menu.close-on-click a", function () {
        $(this).closest(".dropdown-menu").removeClass("show");
    });

    /*

    SELECT2 and its better friends

    */

    //prevent autocomplete on selectize
    $(document).on("focus", ".selectize-control :input", function () {
        $(this).attr("autocomplete", "new-password");
    });

    $(".selectize").selectize({
        plugins: ["remove_button"],
    });

    // Function to get the CSRF token from the hidden input field
    function getCsrfToken() {
        return $('input[name="_token"]').val();
    }

    $(".remove-photo").click(function (e) {
        e.preventDefault();
        if (
            confirm(
                "Are you sure you want to remove this photo? This cannot be undone."
            )
        ) {
            var url = $(this).data("url");
            var button = $(this);

            $.ajax({
                url: url,
                type: "POST",
                headers: {
                    "X-CSRF-TOKEN": getCsrfToken(), // Dynamically set the CSRF token
                },
                data: {
                    _method: "DELETE",
                },
                success: function (response) {
                    if (response.success) {
                        button
                            .closest(".update-media-wrapper")
                            .find(".photo-selector")
                            .remove();
                        button
                            .closest(".update-media-wrapper")
                            .find(".media-controls")
                            .hide();
                        button
                            .closest(".update-media-wrapper")
                            .find(".form-group")
                            .last()
                            .show();
                    } else {
                        alert(
                            "Failed to remove the photo: " + response.message
                        );
                    }
                },
                error: function (response) {
                    alert(
                        "An error occurred while trying to remove the photo."
                    );
                },
            });
        }
    });

    $(".single-selectize").selectize({
        plugins: ["remove_button"],
        labelField: "name",
        searchField: ["name"],
    });

    //used everywhere except CRM
    $(".js-example-basic-multiple").selectize({
        plugins: ["remove_button"],
    });

    //only used on CRM
    $(".js-custom-select").each(function () {
        var selectionPrefix = $(this).data("selection-prefix");
        $(this).select2({
            minimumResultsForSearch: "Infinity",
            dropdownAutoWidth: true,
            width: "auto",
            templateSelection: function (state) {
                return selectionPrefix ? selectionPrefix + state.text : state.text;
            },
        });
    });

    //livewire select2 inputs trigger event
    $(".livewire-select2").on("select2:select select2:unselect", function (e) {
        const param = $(this).data("param");
        const payload = {};
        payload[param] = $(this).val();
        Livewire.dispatch($(this).data("method"), payload);
    });

    // Handle clicking the 'Add Note' button to switch to the notes tab
    $('a[href="#notes"][data-toggle="tab"]').on("click", function (e) {
        e.preventDefault();
        $("#notes-tab").tab("show");
    });

    //ionslider
    //end ionslider

    $("#filterForm").removeClass("d-none");

    $("#app").on("submit", ".ajax-intro-form", function (e) {
        e.preventDefault(); // avoid to execute the actual submit of the form.

        var form = $(this);
        var url = form.attr("action");
        var item_id = form.find("input.item-id-input").first().val();

        $.ajax({
            type: "POST",
            url: url,
            data: form.serialize(), // serializes the form's elements.
            success: function (data) {
                //yay
                form.html("");
                form.next(".note-success").show();
                $(".request-intro-button[data-item-id=" + item_id + "]")
                    .html(
                        ' <i class="far fa-check-circle"></i> Intro Requested!'
                    )
                    .prop("disabled", true);
            },
        });
    });

    /*

    AJAX Add to List and bulk add to list

    */

    $("#app").on("click", ".ajax-add-to-list", function (e) {
        e.preventDefault();

        var currentUrl = window.location.href;
        var targetUrl = $(this).attr("href");
        var parent = $(this).closest(".dropdown").find(".add-to-list-parent");

        startButtonLoading(parent);

        var item = $(this).data("item");
        if (!is_bulk) {
            var currentSelectedIds = $.map(
                $(".item-select-checkbox:checked:visible"),
                function (n, i) {
                    return n.value;
                }
            );
            if (currentSelectedIds.length > 0)
                item = currentSelectedIds.join(",");
        }

        var list = $(this).data("list");
        var link = $(this).data("link");
        var type = $(this).data("type");

        if (is_bulk) {
            fetchBulkIds()
                .done(function (data) {
                    // Assign the fetched IDs
                    item = data.item_ids;

                    // Proceed with the AJAX call to add items
                    addItemsToList(
                        targetUrl,
                        item,
                        type,
                        is_bulk,
                        currentUrl,
                        parent
                    );
                })
                .fail(function () {
                    alert("There was an error fetching bulk IDs.");
                    stopButtonLoading(parent);
                });
        } else {
            addItemsToList(targetUrl, item, type, is_bulk, currentUrl, parent);
        }
    });

    function fetchBulkIds() {
        var currentUrl = window.location.href;
        var url = new URL(currentUrl);
        var params = new URLSearchParams(url.search);
        var pathSegments = url.pathname
            .split("/")
            .filter((segment) => segment !== ""); // Split the path and remove empty segments
        var entityType = pathSegments[0]; // Use the first segment for entityType
        var bulkPath = `/${entityType}/bulk`;
        var bulkUrl = url.origin + bulkPath + "?" + params.toString();

        return $.ajax({
            type: "GET",
            url: bulkUrl,
            headers: {
                "X-CSRF-Token": "{{ csrf_token() }}",
            },
        });
    }

    function addItemsToList(url, item, type, is_bulk, currentUrl, parent) {
        $.ajax({
            type: "POST",
            url: url,
            data: JSON.stringify({
                // Convert data to a JSON string
                item_ids: item, // Pass the array of IDs
                type: type,
                bulk: is_bulk,
                current_url: currentUrl,
            }),
            contentType: "application/json",
            headers: {
                "X-CSRF-Token": $('meta[name="csrf-token"]').attr("content"),
            },
            success: function (data) {
                stopButtonLoading(parent);
                parent.html('&nbsp; <i class="fas fa-check"></i> ');
                window.setTimeout(function () {
                    parent.html("Add to Contact List");
                }, 3000);
            },
            error: function (data) {
                alert(`There was an error: ${data.responseJSON.message}`);
            },
        });
    }

    $("#app").on("click", ".mark-model-hidden", function (e) {
        e.preventDefault();
        var $card = $(this).closest(".item-card-wrapper");
        $card.fadeOut();
        var $pr = $(this).closest(".pitch-request-item");
        $pr.fadeOut();
    });

    /*

    AJAX Set Status and bulk set status

    */

    $("#app").on("click", ".ajax-set-status", function (e) {
        e.preventDefault();

        var currentUrl = window.location.href;
        var targetUrl = $(this).attr("href");
        var parent = $(this).closest(".dropdown").find(".set-status-parent");

        startButtonLoading(parent);

        var item = $(this).data("model");
        var item_id = $(this).data("model-id");
        var status_id = $(this).data("status-id");
        var status_name = $(this).text();
        var type = $(this).data("type");

        if (is_bulk) {
            fetchBulkIds()
                .done(function (data) {
                    item = data.item_ids;
                    setStatusForItems(
                        targetUrl,
                        item,
                        status_id,
                        status_name,
                        type,
                        currentUrl,
                        parent,
                        item_id
                    );
                })
                .fail(function () {
                    alert("There was an error fetching bulk IDs.");
                    stopButtonLoading(parent);
                });
        } else {
            setStatusForItems(
                targetUrl,
                item,
                status_id,
                status_name,
                type,
                currentUrl,
                parent,
                item_id
            );
        }
    });

    function setStatusForItems(
        url,
        item,
        status_id,
        status_name,
        type,
        currentUrl,
        parent,
        item_id
    ) {
        $.ajax({
            type: "GET",
            url: url,
            data: {
                item_ids: item,
                status_id: status_id,
                status_name: status_name,
                type: type,
                current_url: currentUrl,
            },
            headers: {
                "X-CSRF-Token": "{{ csrf_token() }}",
            },
            success: function (data) {
                stopButtonLoading(parent);
                parent.text("Status: " + status_name);
                if (!is_bulk) {
                    $(`tr[data-item-id="${item_id}"]`)
                        .find(".badge")
                        .text(status_name);
                } else {
                    // Assume there's logic to update status for all affected items in the UI when bulk
                    // For example, you might loop over the item_ids and update the UI
                }
            },
            error: function (data) {
                alert(`There was an error: ${data.responseJSON.message}`);
            },
        });
    }

    $("#app").on("click", ".ajax-remove-status", function (e) {
        e.preventDefault();
        var el = $(this);
        var parent = $(this).closest(".dropdown").find(".set-status-parent");

        startButtonLoading(parent);

        $.ajax({
            type: "GET",
            url: $(this).attr("href"),
            headers: {
                "X-CSRF-Token": "{{ csrf_token() }}",
            },
            success: function (data) {
                stopButtonLoading(parent);
                parent.text("Set a Status");
            },
            error: function (data) {
                alert(`There was an error: ${data.responseJSON.message}`);
            },
        });
    });

    $.fn.select2ToTree = function (options) {
        var opts = $.extend({}, options);

        if (opts.treeData) {
            buildSelect(opts.treeData, this);
        }

        opts._templateResult = opts.templateResult;
        opts.templateResult = function (data, container) {
            var label = data.text;
            if (typeof opts._templateResult === "function") {
                label = opts._templateResult(data, container);
            }
            var $iteme = $("<span class='item-label'></span>").append(label);
            if (data.element) {
                var ele = data.element;
                container.setAttribute("data-val", ele.value);
                if (ele.className) container.className += " " + ele.className;
                if (ele.getAttribute("data-pup")) {
                    container.setAttribute(
                        "data-pup",
                        ele.getAttribute("data-pup")
                    );
                }
                if ($(container).hasClass("non-leaf")) {
                    return $.merge(
                        $(
                            '<span class="expand-collapse" onmouseup="expColMouseupHandler(event);"></span>'
                        ),
                        $iteme
                    );
                }
            }
            return $iteme;
        };

        window.expColMouseupHandler = function (evt) {
            toggleSubOptions(evt.target || evt.srcElement);
            /* prevent Select2 from doing "select2:selecting","select2:unselecting","select2:closing" */
            evt.stopPropagation
                ? evt.stopPropagation()
                : (evt.cancelBubble = true);
            evt.preventDefault
                ? evt.preventDefault()
                : (evt.returnValue = false);
        };

        var s2inst = this.select2(opts);

        s2inst.on("select2:open", function (evt) {
            var s2data = s2inst.data("select2");
            s2data.$dropdown.addClass("s2-to-tree");
            s2data.$dropdown.removeClass("searching-result");
            var $allsch = s2data.$dropdown
                .find(".select2-search__field")
                .add(s2data.$container.find(".select2-search__field"));
            $allsch.off("input", inputHandler);
            $allsch.on("input", inputHandler);
        });

        /* Show search result options even if they are collapsed */
        function inputHandler(evt) {
            var s2data = s2inst.data("select2");
            if ($(this).val().trim().length > 0) {
                s2data.$dropdown.addClass("searching-result");
            } else {
                s2data.$dropdown.removeClass("searching-result");
            }
        }

        return s2inst;
    };

    /* Build the Select Option elements */
    function buildSelect(treeData, $el) {
        /* Support the object path (eg: `item.label`) for 'valFld' & 'labelFld' */
        function readPath(object, path) {
            var currentPosition = object;
            for (var j = 0; j < path.length; j++) {
                var currentPath = path[j];
                if (currentPosition[currentPath]) {
                    currentPosition = currentPosition[currentPath];
                    continue;
                }
                return "MISSING";
            }
            return currentPosition;
        }

        function buildOptions(dataArr, curLevel, pup) {
            var labelPath;
            if (treeData.labelFld && treeData.labelFld.split(".").length > 1) {
                labelPath = treeData.labelFld.split(".");
            }
            var idPath;
            if (treeData.valFld && treeData.valFld.split(".").length > 1) {
                idPath = treeData.valFld.split(".");
            }

            for (var i = 0; i < dataArr.length; i++) {
                var data = dataArr[i] || {};
                var $opt = $("<option></option>");
                if (labelPath) {
                    $opt.text(readPath(data, labelPath));
                } else {
                    $opt.text(data[treeData.labelFld || "text"]);
                }
                if (idPath) {
                    $opt.val(readPath(data, idPath));
                } else {
                    $opt.val(data[treeData.valFld || "id"]);
                }
                if (
                    data[treeData.selFld || "selected"] &&
                    String(data[treeData.selFld || "selected"]) === "true"
                ) {
                    $opt.prop("selected", data[treeData.selFld || "selected"]);
                }
                if ($opt.val() === "") {
                    $opt.prop("disabled", true);
                    $opt.val(getUniqueValue());
                }
                $opt.addClass("l" + curLevel);
                if (pup) $opt.attr("data-pup", pup);
                $el.append($opt);
                var inc = data[treeData.incFld || "inc"];
                if (inc && inc.length > 0) {
                    $opt.addClass("non-leaf");
                    buildOptions(inc, curLevel + 1, $opt.val());
                }
            } // end 'for'
        } // end 'buildOptions'

        buildOptions(treeData.dataArr, 1, "");
        if (treeData.dftVal) $el.val(treeData.dftVal);
    }

    var uniqueIdx = 1;

    function getUniqueValue() {
        return "autoUniqueVal_" + uniqueIdx++;
    }

    function toggleSubOptions(target) {
        $(target.parentNode).toggleClass("opened");
        showHideSub(target.parentNode);
    }

    function showHideSub(ele) {
        var curEle = ele;
        var $options = $(ele).parent(".select2-results__options");
        var shouldShow = true;
        do {
            var pup = ($(curEle).attr("data-pup") || "").replace(/'/g, "\\'");
            curEle = null;
            if (pup) {
                var pupEle = $options.find(
                    ".select2-results__option[data-val='" + pup + "']"
                );
                if (pupEle.length > 0) {
                    if (!pupEle.eq(0).hasClass("opened")) {
                        // hide current node if any parent node is collapsed
                        $(ele).removeClass("showme");
                        shouldShow = false;
                        break;
                    }
                    curEle = pupEle[0];
                }
            }
        } while (curEle);
        if (shouldShow) $(ele).addClass("showme");

        var val = ($(ele).attr("data-val") || "").replace(/'/g, "\\'");
        $options
            .find(".select2-results__option[data-pup='" + val + "']")
            .each(function () {
                showHideSub(this);
            });
    }

    $(".select-tree").select2ToTree();
    //this is stupid but it freaks if there's more than one on the page
    $(".select-tree-additional").select2ToTree();

    function showResults() {
        var firstResult = $("#listWrapper tr").first();
        var total = firstResult.data("total");
        var highestConfidence = firstResult.data("confidence");
        $("#investorCount").html(total);
        showTr($("#listWrapper tr").first());
        if (highestConfidence < 3) {
            $("#low-confidence-alert").fadeIn();
        }
        $("#generateList").fadeOut();
    }

    function showMoreResults() {
        // var total = $('#listWrapper tr').first().data('total');
        // $('#investorCount').html(total);
        $(".generate-more-results-wrapper").first().remove();
        showTr($("#listWrapper tr:hidden").first());
    }

    function showTr(el) {
        el.delay(randomIntFromInterval(100, 1000)).fadeIn(function () {
            if (el.next("tr").length) {
                showTr(el.next("tr"));
            } else {
                console.log("all done");
                var total = $("#investorCount").html();
                $(".investor-total-count").html(`${total} Investors Found`);
                // $('#generateMoreMatches').html(`${total} Investors Found`)
            }
        });
    }

    /*

    Link confirm prompt buttons

    */
    $("#app").on("click", ".link-confirm", function (e) {
        return confirm($(this).data("confirm"));
    });

    /*

    Filter Sorting

    */
    var countries = [];
    var countriesInput = $('input[name="countries"]');

    var markets = [];
    var marketsInput = $('input[name="markets"]');

    var sectors = [];
    var sectorsInput = $('input[name="sectors"]');

    var languages = [];
    var languagesInput = $('input[name="languages"]');

    var types = [];
    var typesInput = $('input[name="types"]');

    $(".js-example-basic-multiple, .clone-to-input").on("change", function (e) {
        var inputName = $(this).data("input");
        var selectedValues = $(this).val();

        // Updates the hidden input field value
        $("input[name=" + inputName + "]").val(selectedValues.join());
    });

    // $('.js-example-basic-multiple, .clone-to-input').on('change', function (e) {
    //     var arr = $(this).data('input');
    //     var val = $(this).val();
    //     eval(arr).length = 0;
    //     eval(arr).push(val);
    //     $("input[name=" + arr + "]").val(eval(arr).join());
    // })

    // $('#filterSubmit').on('click', function (e) {
    //     e.preventDefault();
    //     $('.clear-on-submit').prop('disabled', true);
    //     $('#filterForm').submit();
    // })

    function randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    // make the form submitt button show loading when it's ready
    $("form.show-loading-on-submit").on("submit", function (e) {
        var $form = $(this);

        var $submitButton = $form.find('button[type="submit"]:focus');

        if ($submitButton.length === 0) {
            $submitButton = $form.find('input[type="submit"]:focus');
        }

        if ($submitButton.length && $form[0].checkValidity()) {
            e.preventDefault();
            startButtonLoading($submitButton);

            // Small delay to allow visual feedback before form submission
            setTimeout(function () {
                $form[0].submit();
            }, 50);
        }
    });

    function startButtonLoading(el) {
        el.disabled = true;
        el.append(
            '<span class="spinner-border mx-2 spinner-border-sm" role="status" aria-hidden="true"></span>'
        );
    }

    function stopButtonLoading(el) {
        el.disabled = false;
        el.find(".spinner-border").remove();
    }

    // SEO card domain rating hover counter
    var seoCard = document.getElementById("seo-card");
    var seoVal = document.querySelector(".bento-grid__seo-value");
    if (seoCard && seoVal) {
        var seoStart = parseInt(seoVal.dataset.start, 10);
        var seoEnd = parseInt(seoVal.dataset.end, 10);
        var seoCurrent = seoStart;
        var seoTimer = null;

        seoCard.addEventListener("mouseenter", function () {
            clearInterval(seoTimer);
            seoTimer = setInterval(function () {
                if (seoCurrent < seoEnd) {
                    seoCurrent++;
                    seoVal.textContent = seoCurrent;
                } else clearInterval(seoTimer);
            }, 40);
        });

        seoCard.addEventListener("mouseleave", function () {
            clearInterval(seoTimer);
            seoTimer = setInterval(function () {
                if (seoCurrent > seoStart) {
                    seoCurrent--;
                    seoVal.textContent = seoCurrent;
                } else clearInterval(seoTimer);
            }, 40);
        });
    }

    /*

    Character Count Helper
    Shows "X / max" on focus for any input/textarea with a maxlength attribute.

    */
    $(".has-char-count").each(function () {
        var $input = $(this);
        var max = parseInt($input.attr("maxlength"), 10);
        if (!max) return;

        var $wrapper = $input.parent();
        if ($wrapper.css("position") === "static") {
            $wrapper.css("position", "relative");
        }

        var $counter = $(
            '<span class="char-count-helper">' +
                '<span class="char-count-current">0</span> / ' +
                max +
                "</span>"
        );
        $wrapper.append($counter);

        function updateCount() {
            var len = $input.val().length;
            $counter.find(".char-count-current").text(len);
            $counter.toggleClass("char-count-limit", len >= max);
        }

        $input.on("focus", function () {
            updateCount();
            $counter.addClass("visible");
        });

        $input.on("blur", function () {
            $counter.removeClass("visible");
        });

        $input.on("input", updateCount);
    });
})();
